import { IdNameObjectType } from '../../state/models/global-configuration-state.model';
import {
	CREATION_TRIGGER,
	INTEGRATIONS,
	LINE_BUSINESS_LIST,
	MSG_FIELDS_OPTIONS,
} from './product-constant';
import { APPSCOPE_FORM_CONFIG } from './appscope-form-config.model';
import { INSPECTION_FORM_CONFIG } from './inspection-form-config.model';
import { ACUITY_FORM_CONFIG } from './acuity-form-config.model';
import { INSIDE_MAPS_FORM_CONFIG } from './insidemaps-form-config.model';
import { INTEGRATION_FORM_CONFIG } from './integration-form-config.model';
import { LICESING_SERVICE_FORM_CONFIG } from './licesing-service-form-config.model';
import { NEXSYS_FORM_CONFIG } from './nexsys-form-config.model';
import { XPANSE_FORM_CONFIG } from './xpanse-form-config.model';
import { VALUTRUST_FORM_CONFIG } from './valutrust-form-config.model';
import { FNC_FORM_CONFIG } from './fnc-form-config.model';
import { ValidationContext } from '@cv-invision/cv.invision-views.ux';
import { FormGroup } from "@angular/forms";

const OTHER_FORM_CONFIG = {
	subProductConfiguration: {
		products: {
			DataType: 'Array',
			Name: 'products',
			path: 'subProductConfiguration.products',
			DisplayText: 'SubProduct Configuration',
			child: [
				{
					name: {
						DataType: 'Number',
						DisplayText: 'Fee Sidecar 1 ',
						Name: 'name',
						hidden: true,
						required: false,
					},
					id: {
						DataType: 'Selector',
						UIControl: 'Dropdown',
						DisplayText: 'Product Configuration name',
						label: 'Product Configuration name',
						Name: 'id',
						options: [],
						required: false,
						customClass: 'mb-4',
						UIOptions: {
							ShowClearButton: true,
							showLabel: true
						},
						UIEvents: {
							onChange: (
								$event: any,
								model: any,
								formGroup: any,
								formFieldConfig: any
							) => {

								const value = $event.value;
								const formArray = formGroup?.get('subProductConfiguration.products');

								if (value) {
									const indexOptionSelected = formFieldConfig.options.findIndex(element => element.value === value);

									if (indexOptionSelected >= 0) {
										formArray.at(0).get('name')?.setValue(formFieldConfig.options[indexOptionSelected].label);
									}
								} else {
									formArray.at(0).get('name')?.setValue(null);
								}
							},
						},
					},
					subProductFee: {
						DataType: 'Numeric',
						DisplayText: 'Fee Sidecar 1 ',
						Name: 'subProductFee',
						required: false,
						customClass: 'mb-4',
						Visible: function (control, formModelService: ValidationContext) {
							const isProductEnabled = formModelService.FindValue('id');

							return isProductEnabled || false
						}
					},
					creationTrigger: {
						DataType: 'Selector',
						UIControl: 'Dropdown',
						DisplayText: 'Creation Trigger:(Select when the order must be created)',
						label: 'Creation Trigger:(Select when the order must be created)',
						Name: 'creationTrigger',
						required: false,
						customClass: 'mb-4',
						defaultValue: 'IncomingOrder',
						options: CREATION_TRIGGER.map((item: IdNameObjectType) => {
							return {
								label: item.name,
								value: item.id,
							};
						}),
						UIOptions: {
							ShowClearButton: true,
							showLabel: true
						},
						Visible: function (control, formModelService: ValidationContext) {
							const isProductEnabled = formModelService.FindValue('id');

							return isProductEnabled || false
						}
					},
					creationStatusTrigger: {
						DataType: 'Selector',
						UIControl: 'Dropdown',
						DisplayText: 'MileStone',
						label: 'MileStone',
						Name: 'creationStatusTrigger',
						required: false,
						options: [],
						customClass: 'mb-4',
						UIOptions: {
							ShowClearButton: true,
							showLabel: true
						},
						Visible: function (control, formModelService: ValidationContext) {
							const creationTriggerEnabled = formModelService.FindValue('creationTrigger');

							return creationTriggerEnabled === 'StatusChanged' || false
						}
					},
					hybridMode: {
						DataType: 'Boolean',
						DisplayText: `Hybrid Mode`,
						Name: 'hybridMode',
						customClass: 'product-form-switch ms-5',
						required: false,
					}
				},
				{
					name: {
						DataType: 'Number',
						DisplayText: 'Fee Sidecar 1 ',
						Name: 'name',
						hidden: true,
						required: false,
					},
					id: {
						DataType: 'Selector',
						UIControl: 'Dropdown',
						DisplayText: 'Product Configuration name',
						Name: 'id',
						options: [],
						required: false,
						customClass: 'mb-4',
						UIOptions: {
							ShowClearButton: true,
							showLabel: true
						},
						UIEvents: {
							onChange: (
								$event: any,
								model: any,
								formGroup: any,
								formFieldConfig: any
							) => {

								const value = $event.value;
								const formArray = formGroup?.get('subProductConfiguration.products');

								if (value) {
									const indexOptionSelected = formFieldConfig.options.findIndex(element => element.value === value);
									if (indexOptionSelected >= 0) {
										formArray.at(1).get('name')?.setValue(formFieldConfig.options[indexOptionSelected].label);
									}
								} else {
									formArray.at(1).get('name')?.setValue(null);
								}
							},
						},
					},
					hybridMode: {
						DataType: 'Boolean',
						DisplayText: `Hybrid Mode`,
						Name: 'hybridMode',
						required: false,
						customClass: 'product-form-switch ms-5',
					}
				}],
			childFormBuilderConfig: {},
		}
	},
	enableHandheld: {
		DataType: 'Boolean',
		DisplayText: `Enable Handheld Inspection on Demand`,
		Name: 'enableHandheld',
		customClass: 'product-form-switch ms-5 mb-4 mt-4',
		required: false,
		Visible: function(control, jsonModelService: any) {
			const acuityEnabled = jsonModelService.FindRootValue('acuity.enabled');
			return acuityEnabled || false;
		},
		UIEvents: {
			onChange: function($event: any, model: any, formGroup: FormGroup, extraData: any) {
				const inspectionEnabled = formGroup.get('inspection.enabled').value;
				if (inspectionEnabled) {
					formGroup.get('inspection.enabled').setValue(false);
				}

				const is3dProduct = formGroup.get('acuity.is3dProduct').value;

				if (is3dProduct) {
					formGroup.get('acuity.is3dProduct').setValue(false);
				}

				formGroup.get('inspection.schema').setValue('');
				formGroup.get('inspection.softwareCollector').setValue(null);
				formGroup.get('insideMaps.insideMapsId').setValue(null);
				formGroup.get('insideMaps.insideMapsName')?.setValue(null);
				formGroup.get('insideMaps.insideMapsFee').setValue(null);
				formGroup.get('inspection').updateValueAndValidity();
			}
		}
	}
};

export const PRODUCT_FORM_CONFIG = {
	id: {
		DataType: 'String',
		DisplayText: 'Show Product status as Active',
		Name: 'id',
		customClass: 'product-form-switch',
		hidden: true,
		required: false
	},
	active: {
		DataType: 'Boolean',
		DisplayText: 'Show Product status as Active',
		Name: 'active',
		customClass: 'product-form-switch ms-5 mb-4 mt-4',
	},
	title: {
		DataType: 'String',
		DisplayText: 'Title',
		Name: 'title',
	},
	alternativeName: {
		DataType: 'String',
		DisplayText: 'Alternative Name',
		Name: 'alternativeName',
		required: false
	},
	origin: {
		DataType: 'Selector',
		UIControl: 'Dropdown',
		DisplayText: 'Origin (Source of the incoming order)',
		label: 'Line of Business',
		Name: 'origin',
		options: [],
		customClass: 'product-form-dropdown',
		Disabled: function (control, jsonModelService: ValidationContext) {
			const optionEnabled = jsonModelService.FindValue('id');
			return optionEnabled?.trim()?.length > 0;
		},
		UIOptions: {
			ShowClearButton: true,
			showLabel: true,
		},
		UIEvents: {
			onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
				model['acuity']['autoCompleteScopeOrderOption']['uploadDocuments'].DisplayText = `Upload documents inside ${$event.value === 'CMPAcuity' ? 'CMPAcuity (SIDECAR 1)' : $event.value || 'Appscope'} when milestone is:`

				formGroup.get('appScope.enabled')?.setValue(false);
				formGroup.get('acuity.enabled')?.setValue(false);
				formGroup.get('nexsys.enabled')?.setValue(false);
				formGroup.get('valutrust.enabled')?.setValue(false);
				formGroup.get('xpanse.enabled')?.setValue(false);
				formGroup.get('fnc.enabled')?.setValue(false);
				formGroup.get('integration.enabled')?.setValue(false);

				switch ($event.value) {
					case MSG_FIELDS_OPTIONS.APPSCOPE:
					case MSG_FIELDS_OPTIONS.CLASSORDERENTRY:
						formGroup.get('appScope.enabled')?.setValue(true);
						break;
					case MSG_FIELDS_OPTIONS.ACUITY:
					case MSG_FIELDS_OPTIONS.CMPACUITY:
						formGroup.get('acuity.enabled')?.setValue(true);
						break;
				}

				formGroup.updateValueAndValidity();
			},
		},
	},
	channel: {
		DataType: 'Selector',
		UIControl: 'Dropdown',
		DisplayText: 'Line of Business',
		label: 'Line of Business',
		Name: 'channel',
		required: false,
		options: LINE_BUSINESS_LIST.map((item: IdNameObjectType) => {
			return {
				label: item.name,
				value: item.id,
			};
		}),
		UIOptions: {
			ShowClearButton: true,
			showLabel: true,
		},
	},
	productType: {
		DataType: 'Selector',
		UIControl: 'Dropdown',
		DisplayText: 'Product Type',
		label: 'Product Type',
		Name: 'productType',
		required: false,
		options: [],
		UIOptions: {
			ShowClearButton: true,
			showLabel: true,
		},
	},
	valuationType: {
		DataType: 'Selector',
		UIControl: 'Dropdown',
		DisplayText: 'Valuation Type',
		label: 'Valuation Type',
		Name: 'valuationType',
		required: false,
		options: [],
		UIOptions: {
			ShowClearButton: true,
			showLabel: true,
		},
	},
	isOrganizationLevel: {
		DataType: 'Boolean',
		DisplayText: 'Is it at Organization Level Product?',
		Name: 'isOrganizationLevel',
		customClass: 'product-form-switch ms-5 mb-4 mt-4',
		UIEvents: {
			onChange: ($event: any, model: any, formGroup: any, extraData: any) => {

				if ($event.checked) {

					const element = Object.entries(formGroup.value).filter(([key, value]) => (INTEGRATIONS.includes(key) && value['enabled']));

					if (element[0]) {
						const integrationSelected = element[0][0] || null;
						const integrationDefaultConfiguration = formGroup.get(`${integrationSelected}.isDefaultProduct`)?.value

						if (integrationDefaultConfiguration) {
							formGroup.get(`${integrationSelected}.isDefaultProduct`)?.setValue(false)
							formGroup.get(`${integrationSelected}.isFhaProduct`)?.setValue(false)
							formGroup.get(`${integrationSelected}.defaultFhaNumber`)?.setValue(null)
							formGroup.get(`${integrationSelected}.optionSelected`)?.setValue([])
							formGroup.get(`${integrationSelected}.isOrderIncomeStatement`)?.setValue(false)
							formGroup.get(`${integrationSelected}.isOrderRentSchedule`)?.setValue(false)
							formGroup.get(`${integrationSelected}.productId`)?.setValue('')
							formGroup.get(`${integrationSelected}.productName`)?.setValue('')
						}
					}
				}

			},
		},
	},
	isUAD36Product: {
		DataType: 'Boolean',
		DisplayText: 'Is UAD 3.6 Product?',
		Name: 'isUAD36Product',
		customClass: 'product-form-switch ms-5 mb-4 mt-4'
	},
	description: {
		DataType: 'Text',
		DisplayText: 'Description',
		Name: 'description',
	},
	...INSPECTION_FORM_CONFIG,
	...ACUITY_FORM_CONFIG,
	...INSIDE_MAPS_FORM_CONFIG,
	...APPSCOPE_FORM_CONFIG,
	...INTEGRATION_FORM_CONFIG,
	...LICESING_SERVICE_FORM_CONFIG,
	...NEXSYS_FORM_CONFIG,
	...XPANSE_FORM_CONFIG,
	...VALUTRUST_FORM_CONFIG,
	...FNC_FORM_CONFIG,
	...OTHER_FORM_CONFIG
};
